import React from 'react';
import { useDispatch } from 'react-redux';
import useApplicationUid from '../../hooks/useApplicationUid';
import { deleteApplication } from '../../store/actions/application/applicationActions';

const DeleteApplicationPage = () => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();

  const onClick = () => {
    dispatch(
      deleteApplication({
        ApplicationUid,
      }),
    );
  };

  return <button onClick={() => onClick()}>DELETE APPLICATION</button>;
};

DeleteApplicationPage.propTypes = {};

export default DeleteApplicationPage;
